import { AppError } from './AppError';

export class InternalServerError extends AppError {}
